<template>
    <alert color="warning">
        <div class="form-check m-0">
            <label class="form-label form-check-label m-0" :class="readonly ? 'cursor-default' : 'cursor-pointer'" :for="id">
                <input
                    :id="id"
                    :checked="modelValue"
                    :disabled="readonly"
                    class="form-check-input !h-4 !w-4"
                    type="checkbox"
                    @change="!readonly && $emit('update:modelValue', $event.target.checked)"
                />
                <span v-html="trans(reminderKey)" />
                <em class="ms-1 text-danger">*</em>
            </label>
        </div>
    </alert>
</template>

<script setup>
import Alert from '@/Components/Alert.vue';
import { trans } from '@/mixins/i18n.js';

defineProps({
    modelValue: { type: Boolean, required: true },
    reminderKey: { type: String, required: true },
    id: { type: String, required: true },
    readonly: { type: Boolean, default: false },
});

defineEmits(['update:modelValue']);
</script>
